
export const replaceCharsAndSpaces = (string) => {
    //console.log(string);
    return string.toString().replace(/[, ]+/g, '').trim()
}
